import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";

import GeofenceAlerts from "../../../containers/reports2/geofence-alerts";

class GeofenceAnalytics extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.drill-downs-geofence" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <GeofenceAlerts />
      </Fragment>
    );
  }
}
export default GeofenceAnalytics;
